import Modal from '../index';

import baseTemplate from './index.html';
import header from '../partials/header.html';
import footer from '../partials/footer.html';

const template = header + baseTemplate + footer;

export default Modal.extend({

  name: 'CalenderModal',

  template,

  data: () => ({
    showCloseBtn: true,
  }),
});



// WEBPACK FOOTER //
// ./src/js/components/modals/calender/index.js